<template>
    <div class="sh050" id="sh050">
        <!-- ご注文手続き -->
        <h2 class="">{{$t("common.labels.orderProcedure")}}</h2>
        <div class="sh050PayDetailMain">
            <div style="display:none;">
                <span id="pointsTouseThisTime_lbl">{{$t('common.labels.pointsTouseThisTime')}}</span>
                <span id="errorCashDelivery_lbl">{{$t('sh050.labels.errorCashDelivery')}}</span>
                <span id="errorPaymentSlip_lbl">{{$t('sh050.labels.errorPaymentSlip')}}</span>
                <span id="errorMailservice_lbl">{{$t('sh050.labels.errorMailservice')}}</span>
            </div>
            <div class="sh050PayDetail">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="SH050_PART"/>
                <br />
                <h4>{{$t("sh050.labels.usePointSet")}}</h4>
                <br />
                <p class="mb32">{{$t("sh050.labels.preferredUsePointSet")}}</p>
                <!--ポイント利用の場合 -->
                <table class="sh050PaytblPerson sh050Paytblmb32" v-if="pointFlg">
                    <tbody>
                        <template>
                            <!--請求金額 -->
                            <tr v-if="sh050RespModel.seikyuKin >= 0 && sh050RespModel.shouhinAnbunOption == 0">
                                <th class="register-check w200">
                                    <strong v-if="sh050RespModel.tnkDspKbn == '1'">{{$t('sh060.labels.billedamount(taxincluded)')}}</strong>
                                    <strong v-else>{{$t('sh060.labels.billedamount(excludingtax)')}}</strong>
                                </th>
                                <td>
                                    <span class="price">{{formatPrice(sh050RespModel.seikyuKin)}}円</span>
                                </td>
                            </tr>
                            <tr v-else-if="sh050RespModel.seikyuKinWithoutTesuu >= 0">
                                <th class="register-check w300">
                                    <strong v-if="sh050RespModel.tnkDspKbn == '1'">ご商品合計金額（税込）</strong>
                                    <strong v-else>ご商品合計金額（税抜）</strong>
                                </th>
                                <td>
                                    <span class="price">{{formatPrice(sh050RespModel.seikyuKinWithoutTesuu)}}円</span>
                                </td>
                            </tr>
                            <!--保持ポイント -->
                            <tr>
                                <th class="register-check w200">
                                    <strong>{{$t("sh050.labels.point")}}</strong>
                                </th>
                                <td>
                                    <span class="totalPoint">{{formatPrice(sh050RespModel.totalPointFmt)}}{{$t("sh050.labels.pt")}}</span>
                                </td>
                            </tr>
                            <!--利用可能ポイント 
                            <tr>
                                <th class="register-check w200">
                                    <strong>{{$t("sh050.labels.availablePoints1")}}</strong>
                                </th>
                                <td>
                                    <span>{{formatPrice(sh050RespModel.availablePointFmt)}}{{$t("sh050.labels.pt")}}</span>
                                </td>
                            </tr>-->
                            <!--今回ご利用ポイント -->
                            <tr id="point_tr" class="point_tr">
                                <th class="register-check w200">
                                    <strong>{{$t("sh050.labels.availablePoints2")}}</strong>
                                </th>
                                <td id="point_td" class="point_td">
                                    <input type="radio" name="point_kbn" :value="'0'"
                                        :id="'_point_kbn_0'" :checked="'0' == sh050RespModel.pointKbn ? 'checked':''" v-model="sh050RespModel.pointKbn" @click="selectPoint('0')"/>
                                    <label :for="'_point_kbn_0'">{{$t("sh050.labels.allPoint")}}</label>

                                    <input type="radio" name="point_kbn" :value="'1'"
                                        :id="'_point_kbn_1'" :checked="'1' == sh050RespModel.pointKbn ? 'checked':''" v-model="sh050RespModel.pointKbn" @click="selectPoint('1')"/>
                                    <label :for="'_point_kbn_1'">{{$t("sh050.labels.partPoint")}}</label>
                                    <input-number type="text" :maxlength="7" :style="'width:100px; background-color:'+background" :disabled="disable" v-model="sh050RespModel.pointUsed" name="pointUsed"/>{{$t("sh050.labels.pt")}}

                                    <input type="radio" name="point_kbn" :value="'2'"
                                        :id="'_point_kbn_2'" :checked="'2' == sh050RespModel.pointKbn ? 'checked':''" v-model="sh050RespModel.pointKbn" @click="selectPoint('2')"/>
                                    <label :for="'_point_kbn_2'">{{$t("sh050.labels.notPoint")}}</label>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
                <p class="sh050Paytblmb32" v-if="sh050RespModel.shouhinAnbunOption == 1">
                    <span v-html="sh050RespModel.shouhinAnbunString"></span>
                </p>
                <p class="sh050Paytblmb32" v-if="sh050DoInit.teikiPointRiyouSetting == 1">
                    <span>{{$t("sh050.labels.teikiRemaindMsse")}}</span>
                </p>
                <p class="sh050Paytblmb32" v-if="descriptionInfo[7] != ''">
                    <span v-html="descriptionInfo[7]"></span>
                </p>
                <ul class="button-column mb32">
                    <li>
                        <button @click="backPage" type="button">{{$t("common.buttons.backtothepreviouspage")}}</button>
                    </li>
                    <li>
                        <input type="submit" :value="$t('sh050.buttons.update')" :alt="$t('sh050.buttons.submit')" @click="submit" class="submit-button">
                    </li>
                </ul>
                <p class="sh050Paytblmb32">
                    {{$t('common.labels.note1')}}
                    <a @click="selectLink" :title="$t('common.labels.noteLink')" class="blank" target="_blank">{{$t('common.labels.noteLink')}}</a>
                    {{$t('common.labels.note2')}}
                </p>
            </div>
        </div>
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from "components/InputNumber";
export default {
    /* 
    * Name of component
    */
    name: "SH050ShopperPayDetails",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },

    /* 
    * Get data from parent component
    */
    components:
    {
		EventBus,
		Message,
		InputNumber
    },
    data() {
        return {
            sh050DoInit:{
                descriptionInfo:{}
            },
            originSiharaiHohoKbn:null,
            originPointKbn:null,
            originPointUsed:null,
            sh050SiharaiHohoKbnList:{},
            listIdErr:[],
            sh050ReqModel:{},
			sh050RespModel:{
                pointKbn: '0',
                siharaiHohoKbn: null
            },
            descriptionInfo:[],
			SiteConstants: SiteConstants,
			SH050_PART:'sh050',
            listMessValid:[],
            mapMessValid:[],
            site: "",
            pointFlg : false,
            disable : false,
            background: "",
            inputPoint: 0,
            hatchuCnt: 0,
            entetsuPoint: 0,
            entetsuKainInfo: {},
        }
    },
    /*
    * 初期処理
    */
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if(sessionStorage['hopeDayList']) {
            _this.hatchuCnt = JSON.parse(sessionStorage['hopeDayList']).length;
            _this.sh050ReqModel.hatchuCnt = _this.hatchuCnt;
        }

        if (_this.ptInitData){
            _this.$emit("event-loading", true);
            try {
                _this.sh050DoInit = _this.ptInitData;
                _this.sh050SiharaiHohoKbnList = _this.ptInitData.resultSiharaiHohoKbnList;

                if (_this.sh050DoInit.entetsuFlg == 1 && _this.sh050DoInit.entetsuAutoLoginFlg == 1){
                    if (sessionStorage.getItem('kainInfo')){
                        _this.entetsuKainInfo = JSON.parse(sessionStorage.getItem('kainInfo'));
                        _this.entetsuPoint = _this.entetsuKainInfo.kanouPoint;
                        _this.sh050ReqModel.totalPoint = _this.entetsuPoint;
                        _this.sh050ReqModel.totalPointFmt = _this.entetsuPoint;
                        _this.sh050RespModel.totalPointFmt = _this.entetsuPoint;
                    }
                }

                _this.sh050RespModel = _this.ptInitData.reqModel;
                _this.inputPoint =  _this.ptInitData.reqModel.pointUsed;
                // 初期値を最初の決済にする
                if (_this.sh050RespModel.siharaiHohoKbn == "993" || !_this.sh050RespModel.siharaiHohoKbn) {
                    _this.sh050RespModel.siharaiHohoKbn = _this.sh050SiharaiHohoKbnList[0].KEY;
                }
                _this.descriptionInfo = _this.sh050DoInit.descriptionInfo;
                // ポイント利用オプションの場合表示をON
                if (_this.sh050RespModel.pointFlg == 1) {
                    _this.pointFlg = true;
                }
                //ポイント利用区分選択
                _this.selectPoint(_this.sh050RespModel.pointKbn);
            } catch (error) {
                common.errorAPI(error);
            }finally{
                _this.$emit("event-loading", false);
            }
        }else{
            _this.$emit("event-loading", true);
            // eslint-disable-next-line
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH050 + _this.$UrlConstants.DO_INIT ,_this.sh050ReqModel).then(function(response) {
                _this.sh050DoInit = response.data;
                _this.sh050SiharaiHohoKbnList = response.data.resultSiharaiHohoKbnList;

                _this.sh050RespModel = response.data.reqModel;

                if (_this.sh050DoInit.entetsuFlg == 1 && _this.sh050DoInit.entetsuAutoLoginFlg == 1){
                    if (sessionStorage.getItem('kainInfo')){
                        _this.entetsuKainInfo = JSON.parse(sessionStorage.getItem('kainInfo'));
                        _this.entetsuPoint = _this.entetsuKainInfo.kanouPoint;

                        _this.sh050ReqModel.totalPoint = _this.entetsuPoint;
                        _this.sh050ReqModel.totalPointFmt = _this.entetsuPoint;
                        _this.sh050RespModel.totalPointFmt = _this.entetsuPoint;
                    }
                }

                _this.inputPoint =  response.data.reqModel.pointUsed;
                // 初期値を最初の決済にする
                if (_this.sh050RespModel.siharaiHohoKbn == null || _this.sh050RespModel.siharaiHohoKbn == undefined 
                    || _this.sh050RespModel.siharaiHohoKbn == "993" || _this.sh050RespModel.siharaiHohoKbn == "" ) {
                    _this.sh050RespModel.siharaiHohoKbn = _this.sh050SiharaiHohoKbnList[0].KEY;
                }
                _this.descriptionInfo = _this.sh050DoInit.descriptionInfo;
                // ポイント利用オプションの場合表示をON
                if (_this.sh050RespModel.pointFlg == 1) {
                    _this.pointFlg = true;
                }
                //ポイント利用区分選択
                _this.selectPoint(_this.sh050RespModel.pointKbn);
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        }
        _this.originSiharaiHohoKbn = _this.sh050RespModel.siharaiHohoKbn;
        _this.originPointKbn = _this.sh050RespModel.pointKbn;
        _this.originPointUsed = _this.sh050RespModel.pointUsed;
        //Call method selectLink when selecting links on DataTable
        EventBus.$on("select-link", function(selectData) {
            _this.selectLink(selectData);
        });
    },
    methods: {
        /*
        * 内容確認画面へ
        */
     submit: async function(){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH050_PART);
            // ポイントチェック
            await _this.pointCheck();
            _this.$emit("event-loading", true);

            if (_this.sh050DoInit.entetsuFlg == 1 && _this.sh050DoInit.entetsuAutoLoginFlg == 1){
                    _this.sh050RespModel.availablePoint = _this.entetsuPoint;
                    _this.sh050RespModel.availablePointFmt = _this.entetsuPoint;
            }

            await axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH050 + _this.$UrlConstants.DO_UPDATE,_this.sh050RespModel).then(function(response) {
                if(response.data.status == "OK"){
                    if (_this.sh050RespModel.siharaiHohoKbn == "993") {
                        sessionStorage.removeItem('amazonCheckoutSessionId');
                    }
                    sessionStorage.setItem('totalPointKin', _this.sh050RespModel.pointUsed);
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22}});
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if (_this.sh050RespModel.siharaiHohoKbn == "993") {
                    _this.sh050RespModel.siharaiHohoKbn = _this.sh050SiharaiHohoKbnList[0].KEY;
                }
                if(error != null && error != undefined){
                    _this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH050_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                common.scrollTop();
            });
        },
        /*
        * Function selectLink
        */
        selectLink: function() {
            var _this = this;
            var pagedata = _this.$router.resolve({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 70}});
            window.open(pagedata.href,'_blank');
        },
		backPage: function(){
			var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH050_PART);
			_this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22}});
		},

        // 支払い方法選択AJAX
		selectSiharaiHoho: async function(key){
			var _this = this;
			_this.sh050RespModel.siharaiHohoKbn = key;
            await axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH050 + _this.$UrlConstants.DO_AJAX, _this.sh050RespModel).then(function(ajaxRespone) {
                _this.sh050RespModel.seikyuKin = ajaxRespone.data.seikyuKin;
                _this.sh050RespModel.availablePointFmt = ajaxRespone.data.reqModel.availablePoint;
                sessionStorage.setItem('totalPointKin', _this.sh050RespModel.availablePointFmt);
                //ポイント利用区分選択
                _this.selectPoint(_this.sh050RespModel.pointKbn);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
                common.scrollTop();
            });
		},
        /*
        * ポイント利用区分選択
        */ 
        selectPoint: function (value) {
            var _this = this;
            let totalPointKin = parseInt(common.numberNvl(sessionStorage['totalPointKin']), 10);
            if (_this.sh050RespModel.availablePoint && _this.sh050RespModel.availablePoint <= totalPointKin) {
                totalPointKin = _this.sh050RespModel.availablePoint;
            }
            // 利用ポイント
            var pointUsedCalc = totalPointKin > 0 ? totalPointKin : _this.sh050RespModel.pointUsed;
            //利用可能ポイント
            var availablePointCalc = _this.sh050RespModel.availablePointFmt;
            switch (value) {
                // すべて使う
                case "0":
                    pointUsedCalc = availablePointCalc;
                    _this.inputPoint = 0;
                    _this.disable = true;
                    _this.background = "#C0C0C0;";
                break;
                // 一部使う
                case "1":
                    _this.disable = false;
                    _this.background = "";
                break;
                // 使わない
                case "2":
                    pointUsedCalc = 0;
                    _this.inputPoint = 0;
                    _this.disable = true;
                    _this.background = "#C0C0C0;";
                break;
            }
            _this.sh050RespModel.pointUsed = pointUsedCalc;
        },
        /*
        * ポイントチェック
        */
        pointCheck: async function() {
            var _this = this;

            // クレジットカード以外で全額ポイントが選ばれていた場合または利用ポイントと請求金額が同じ場合
            if ((_this.sh050RespModel.pointKbn == "0" && _this.sh050RespModel.seikyuKin == 0)
                || _this.sh050RespModel.pointUsed == _this.sh050RespModel.seikyuKin
                || _this.sh050RespModel.pointUsed == _this.sh050RespModel.seikyuKinWithoutTesuu) {
                // 強制的に全額ポイント
                let kessaiCd = "";
                if (_this.sh050RespModel.shouhinAnbunOption == 0) {
                    kessaiCd = "993";
                    _this.sh050RespModel.siharaiHohoKbn = kessaiCd;
                } else if (_this.sh050RespModel.siharaiHohoKbn == "993") {
                    _this.sh050RespModel.siharaiHohoKbn = kessaiCd;
                } else {
                    kessaiCd = _this.sh050RespModel.siharaiHohoKbn;
                }
               
                // 請求金額計算AJAX
                await _this.selectSiharaiHoho(kessaiCd);
            }
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        }
    },
    /*
    * destroy eventbus of page before close page
    */
    beforeDestroy: function() {
        //close select-link eventbus
        EventBus.$off("select-link");
    }
}
</script>
